import { render } from "./BaseDateField.vue?vue&type=template&id=ca40c7ee&scoped=true"
import script from "./BaseDateField.vue?vue&type=script&lang=js"
export * from "./BaseDateField.vue?vue&type=script&lang=js"

import "./BaseDateField.vue?vue&type=style&index=0&id=ca40c7ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca40c7ee"]])

export default __exports__